var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"full-height"},[(!_vm.isValidLayout)?_c('LayoutCheck',{attrs:{"calledFrom":"unAuth"},on:{"valid-layout":function($event){_vm.isValidLayout = true},"is-vendor":function($event){_vm.isVendor = true}}}):_c('Login',{attrs:{"isVendor":_vm.isVendor}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }